import StatelessSwitcher from './StatelessSwitcher';

export default StatelessSwitcher;



// WEBPACK FOOTER //
// ./src/components/common/StatelessSwitcher/index.js